/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { getToken } from './api';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ==================== NOTIFICATION TYPES ====================

export interface Notification {
  id: number;
  user_id: number;
  notification_type: string;
  title: string;
  body: string;
  channel: string;
  is_read: boolean;
  read_at: string | null;
  action_url: string | null;
  action_data: Record<string, any>;
  reference_type: string | null;
  reference_id: number | null;
  created_at: string;
}

export interface NotificationListResponse {
  items: Notification[];
  total: number;
  page: number;
  page_size: number;
  unread_count: number;
}

export interface UnreadCountResponse {
  unread_count: number;
}

// ==================== NOTIFICATION API ====================

export const notificationApi = {
  getNotifications: async (params?: {
    page?: number;
    page_size?: number;
    unread_only?: boolean;
  }): Promise<NotificationListResponse> => {
    const response = await apiClient.get('/notifications/', { params });
    return response.data;
  },

  getUnreadCount: async (): Promise<UnreadCountResponse> => {
    const response = await apiClient.get('/notifications/unread-count');
    return response.data;
  },

  markAsRead: async (id: number): Promise<Notification> => {
    const response = await apiClient.put(`/notifications/${id}/read`);
    return response.data;
  },

  markAllRead: async (): Promise<{ message: string; marked_count: number }> => {
    const response = await apiClient.post('/notifications/mark-all-read');
    return response.data;
  },

  registerDeviceToken: async (data: {
    platform: string;
    token: string;
  }): Promise<any> => {
    const response = await apiClient.post('/notifications/device-token', data);
    return response.data;
  },

  removeDeviceToken: async (token: string): Promise<void> => {
    await apiClient.delete('/notifications/device-token', {
      data: { token },
    });
  },
};

export default notificationApi;
